import React from 'react';
import unpick from '../../../utilities/unpick';

export default function Checkbox(props) {
  const { isValid } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'value', 'valueWhenChecked']);

  const checked = props.value === props.valueWhenChecked;

  return (
    <input
      type="checkbox"
      {...p}
      aria-label={props.ariaLabel || 'Checkbox'}
      aria-invalid={!isValid}
      checked={checked}
    />
  );
}

Checkbox.propTypes = {};
